module.exports = __webpack_public_path__ + "static/icons/interseguro-agora.0c30b6a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-home/promotions/interseguro-agora.gif
// module id = WHUW
// module chunks = 1